let shared = null;

export const getAudio = () => {
  if (!shared) {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const out = ctx.createGain();
    out.connect(ctx.destination);
    const rec = ctx.createMediaStreamDestination ? ctx.createMediaStreamDestination() : null;
    if (rec) out.connect(rec);
    const keepAlive = () => ctx.state === "suspended" && ctx.resume().catch(() => {});
    ctx.addEventListener("statechange", keepAlive);
    document.addEventListener("visibilitychange", keepAlive);
    shared = { ctx, out, rec };
  }
  if (shared.ctx.state === "suspended") shared.ctx.resume().catch(() => {});
  return shared;
};
